"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultView = exports.defaultText = exports.defaultColor = exports.defaultButton = void 0;
var defaultText = {
  disabled: 'title1_baseWhite',
  selected: 'title1_baseWhite',
  unselected: 'title1_baseWhite'
};
exports.defaultText = defaultText;
var defaultColor = {
  disabled: 'baseWhite',
  selected: 'baseWhite',
  unselected: 'baseWhite'
};
exports.defaultColor = defaultColor;
var defaultView = {
  backgroundColor: 'baseWhite',
  border: {
    colors: defaultColor,
    width: 1
  },
  cornerRadius: 5
};
exports.defaultView = defaultView;
var defaultButton = {
  stateBackgroundColors: defaultColor,
  stateTextStyles: defaultText,
  view: 'defaultView'
};
exports.defaultButton = defaultButton;